// extracted by mini-css-extract-plugin
export var externalLink = "schema-link-for-content-module--externalLink--e3a03";